/* tslint:disable */

declare var Object: any;
export interface SFLoanRequestInterface {
  "id"?: number;
}

export class SFLoanRequest implements SFLoanRequestInterface {
  "id": number;
  constructor(data?: SFLoanRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFLoanRequest`.
   */
  public static getModelName() {
    return "SFLoanRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFLoanRequest for dynamic purposes.
  **/
  public static factory(data: SFLoanRequestInterface): SFLoanRequest{
    return new SFLoanRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFLoanRequest',
      plural: 'SFLoanRequests',
      path: 'SFLoanRequests',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFLoanRequest.ts